import React from 'react';
import GradientBackground from 'app/ui/core/common/GradientBackground';
import BrandedLogo from 'app/ui/config/BrandedLogo';
import './style/SimpleHeaderFrame.scss';
import withMediaQuery from '../../core/common/withMediaQuery';
import { TABLET } from '../../style/common/breakpoints';
import { DEFAULT } from '../../../api/redux-route/routes';
import { Link } from 'react-router-dom';

function SimpleHeaderFrame({
  children,
  mediaQueryMatches,
  defaultHeight,
  tabletHeight,
  defaultLeft,
  tabletLeft,
  disableLogoLink,
}) {
  const logo = (
    <BrandedLogo logoKey="common.logo" height={41} tabletHeight={31} />
  );

  return (
    <div className="SimpleHeaderFrame">
      <div
        className="SimpleHeaderFrame__BannerArea"
        style={{
          height: mediaQueryMatches ? tabletHeight : defaultHeight,
        }}
      >
        <GradientBackground>
          <div
            className="SimpleHeaderFrame__Logo"
            style={{
              paddingLeft: mediaQueryMatches ? tabletLeft : defaultLeft,
            }}
          >
            {disableLogoLink ? logo : <Link to={DEFAULT}>{logo}</Link>}
          </div>
        </GradientBackground>
      </div>
      <div className="SimpleHeaderFrame__Content">{children}</div>
    </div>
  );
}

SimpleHeaderFrame.defaultProps = {
  defaultHeight: 80,
  tabletHeight: 60,
  defaultLeft: 30,
  tabletLeft: 24,
};

export default withMediaQuery(TABLET)(SimpleHeaderFrame);
